import React from 'react'
import { Row, Container } from 'react-bootstrap';
import './casestudybody32.css';

import clientimg from '../images/case-study-client32.webp'
import outcome from '../images/outcome32.webp'

import sm1 from '../images/cs32so1.webp'
import sm2 from '../images/cs32so2.webp'
import sm3 from '../images/cs32so3.webp'
import sm4 from '../images/cs32so4.webp'
import sm5 from '../images/cs32so5.webp'


const Casestudybody32 = () => {

    return (
        <>
        <section className='casestudybody32-section'  >
          <Container>

            <Row className='w-100 py-md-5 py-4 clintrow'>
                <div className='col-md-4 relative order-1'>
                  <div className='left-box'>
                    <div className='content-box'>
                      <h2>About</h2>
                      {/* <div className="h1"><span className='h1 animate-underline' style={{ paddingBottom: "40px" }}>The Client</span></div> */}
                      <div className="h1">The Client</div>
                      <p className='anima '><span className='only-anima-underline' > **** </span></p>
                      <p>A diversified infrastructure-focused investment fund managing an AUM of ~USD 12 Bn</p>
                    </div>
                  </div>
                           
                </div>
                <div className='col-md-8 right-box'>
                    <img src={clientimg} alt="" />
                </div>
            </Row>
       
            <Row className='mt-md-5'>
              <div className='col-md-12'>
                <div className='content-box'>
                  <h2>Situation</h2>
                  {/* <div className="h1"><span className='h1 animate-underline' style={{ paddingBottom: "40px" }}>The Client</span></div> */}
                  <div className="h1">Overview</div>
                  <p className='anima '><span className='only-anima-underline' > **** </span></p>
                  <p>The client initiated Joint Venture Proposal with the aim to maximize the asset's full potential after gathering a comprehensive understanding of the counterparty's business and the financial implications of the JV</p>
                </div>
                
              </div>
            </Row>
          </Container>
        </section>
    
        <section className='casestudybody32-section bg-gredient-dark'>
          <Container>
            <Row>
              <div className='col-md-12'>
                  <div className='content-box'>
                    <h2>Approach &</h2>
                    {/* <div className="h1"><span className='h1 animate-underline' style={{ paddingBottom: "40px" }}>The Client</span></div> */}
                    <div className="h1">Methodology</div>
                    <p className='anima '><span className='only-anima-underline' > **** </span></p>
                    {/* <p>The next step was to put together and implement a step-by-step process for conducting the valuation:</p> */}
                  
                    <div className='list-text my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>
                        <div className='text'>
                          <h4>Kick-off Discussion: </h4>
                          <p>Commenced <span style={{color:"#01C6B2"}}>project initiation discussion</span> with the client to gather crucial information regarding the key project requirements</p>
                        </div>
                      </div>
    
                      <div className='list-text my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>
                        <div className='text'>
                          <h4>Identification Of The Right Partner:</h4>
                          <p>Conducted <span style={{color:"#01C6B2"}}>rigorous research to identify</span> fitting partners for a <span style={{color:"#01C6B2"}}>Joint Venture</span>, taking into consideration the client's requirements</p>
                        </div>
                      </div>
    
                      <div className='list-text my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>

                        <div className='text'>
                          <h4>Formulation of Preliminary Proposal:</h4>
                          <p>Prepared <span style={{color:"#01C6B2"}}>preliminary proposal encompassing roles, responsibilities, financial implications, and mutual benefits</span> for both parties involved in the Joint Venture</p>
                        </div>
                      </div>

                      <div className='list-text my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>

                        <div className='text'>
                          <h4>Evaluation of Counter-Proposal: </h4>
                          <p>Conducted an <span style={{color:"#01C6B2"}}>exhaustive analysis of the proposal</span>, scrutinizing comprehensive data on tangible and intangible asset contributions, shareholder stakes, and assessing the benefits and impacts on the firm</p>
                        </div>
                      </div>                 

                      <div className='list-text my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>

                        <div className='text'>
                          <h4>Refined Negotiation Strategy:</h4>
                          <p>Formulated a refined <span style={{color:"#01C6B2"}}>negotiation strategy and revised the firm's proposal</span>, providing a succinct and comprehensive outline of the roles, financial implications, and benefits for both parties involved in the JV</p>
                        </div>
                      </div> 

                      <div className='list-text last-child my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>

                        <div className='text'>
                          <h4>Joint Venture Agreement:</h4>
                          <p>Upon mutual acceptance of the revised proposal, the <span style={{color:"#01C6B2"}}>parties proceed to formalize their partnership through a Joint Venture Agreement</span> encompassing the allocation of profits and losses, as well as delineating the respective responsibilities of both entities</p>
                        </div>
                      </div> 
                     
                      <h3 className='mt-5'>Sample Output</h3>
                      <div className='sample-output mt-3'>
                        <img src={sm1} alt=''/>
                        <img src={sm2} alt=''/>
                        <img src={sm3} alt=''/>
                        <img src={sm4} alt=''/>
                        <img src={sm5} alt=''/>
                      </div>
                  </div>
                  
                </div>
            </Row>
          </Container>
        </section>

    
        <section className='casestudybody32-section outcome'  >
          <Container>
            <Row className='w-100 pb-5 clintrow '>
                <div className='col-md-4 relative order-1'>
                  <div className='left-box'>
                    <div className='content-box'>
                      <div className="h1">Outcome</div>
                      <p className='anima '><span className='only-anima-underline' > **** </span></p>
                      <p>The client was provided with a recommended proposal that outlined the advantages and potential consequences, after a comprehensive assessment of the initial proposals from both parties</p>  
                    </div>
                  </div>
                           
                </div>
                <div className='col-md-8 right-box'>
                    <img src={outcome} alt="" />
                </div>
            </Row>
       
          </Container>
        </section>
    
        </>  
      )
    }

export default Casestudybody32
